import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import DrawerLayout from '../../components/shared/DrawerLayout';
import ReceiptDrawerBody from './ReceiptDrawerBody';
import {
  closeReceiptDrawerAndSetQueries,
  selectViewMode,
} from '../../redux/store/ui/common';
import { selectSelectedReceipt } from '../../redux/store/userData/receipts';
import { ViewMode } from '../../hooks/viewMode';
import NestedDrawer from '../shared/NestedDrawer';

const ReceiptDrawer: React.FC = () => {
  const dispatch = useDispatch();
  const viewMode = useSelector(selectViewMode);
  const selectedReceipt = useSelector(selectSelectedReceipt);
  const visible = selectedReceipt != null;

  const handleOnClose = () => {
    dispatch(closeReceiptDrawerAndSetQueries());
  };

  return (
    selectedReceipt && (
      <DrawerLayout
        visible={visible}
        title={selectedReceipt?.id!}
        body={<ReceiptDrawerBody />}
        nestedDrawers={
          <>
            {viewMode !== ViewMode.SHARE && <NestedDrawer name="trip" />}
            {viewMode !== ViewMode.USERS && <NestedDrawer name="users" />}
          </>
        }
        onReload={undefined}
        onClose={handleOnClose}
      />
    )
  );
};

export default ReceiptDrawer;
